import React from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  Col,
  Tab,
  Modal,
  Row,
  Accordion,
  OverlayTrigger,
  Tooltip,
  Spinner,
  Container,
} from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import { useDispatch, useSelector } from "react-redux";
import { Document, Page, pdfjs } from "react-pdf";
import { revisiPengajuan } from "stores/Pengajuan/function";
import { updateStatusPengajuan } from "stores/Pengajuan/function";
import { pengajuanBPD } from "stores/Pengajuan/function";
import moment from "moment";
import { getAllPengajuan } from "stores/Pengajuan/function";
import { number } from "prop-types";
import Select from "react-select";
import CurrencyInput from "react-currency-input-field";
import NumberFormat from "react-number-format";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import SplitText from "views/SplitText";
import { uploadSkl } from "stores/Pengajuan/function";
import { uploadSlipTakeOver } from "stores/Pengajuan/function";
import { Label } from "reactstrap";
import FotoKunjungan from "./FotoKunjungan";
import { uploadFotoPencairan } from "stores/Pengajuan/function";

function indexSteps() {
  const dispatch = useDispatch();
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const korcab = useSelector((state) => state.korcabReducer);
  const [listUrlDokumen, setListUrlDokumen] = React.useState([]);
  const valDetailStepEnam = !pengajuan.detailPengajuan.stepEnam
    ? []
    : pengajuan.detailPengajuan.stepEnam;

  const valDetail = pengajuan.detailPengajuan;
  // console.log(valDetail, "KKKK");
  const urlPreview = pengajuan.urlDokumen;

  const judulPdf = pengajuan.titlePreview;
  const [modalRevisi, setModalRevisi] = React.useState(false);
  const [modalUpdateStatus, setModalUpdateStatus] = React.useState(false);
  const [keterangan, setKeterangan] = React.useState("");
  const [nominalPencairan, setNominalPencairan] = React.useState("");
  const [nominalPelunasan, setNominalPelunasan] = React.useState("");
  const [noAkad, setNoAkad] = React.useState("");
  const [tanggalAkad, setTanggalAkad] = React.useState("");
  const [periodeRekon, setPeriodeRekon] = React.useState("");
  const [noRekeningKredit, setNoRekeningKredit] = React.useState("");
  const [kirimFotoPencairan, setKirimFotoPencairan] = React.useState("");
  const [noAgenda, setNoAgenda] = React.useState("");
  const [tanggalAgenda, setTanggalAgenda] = React.useState("");
  const [jenisAsuransi, setJenisAsuransi] = React.useState("");
  const [biayaAsuransi, setBiayaAsuransi] = React.useState("");
  const [biayaProvisi, setBiayaProvisi] = React.useState("");
  const [biayaAdministrasi, setBiayaAdministrasi] = React.useState("");
  const [biayaNotaris, setBiayaNotaris] = React.useState("");
  const [analis, setAnalis] = React.useState("");
  const [blokirAngsuran, setBlokirAngsuran] = React.useState("");
  const [idPengajuan, setIdPengajuan] = React.useState("");
  const [status, setStatus] = React.useState("");
  const auth = useSelector((state) => state.authReducer);
  const userRole = auth.role;
  const [loadingFotoPencairan, setLoadingFotoPencairan] = React.useState(false);
  const isSupervisor = auth.role === "supervisor";
  const isKorcab = auth.role === "client" && auth.jabatan === "korcab";
  const isKonsumer =
    auth.nopeg === "rizalrompis" || auth.nopeg === "susansampangai";

  const isDisabled =
    (isSupervisor && valDetail.approvalSupervisor) || // Supervisor disable jika approvalSupervisor true
    (isKorcab && valDetail.approvalKorcab) || // Korcab disable jika approvalKorcab true
    (isKonsumer && valDetail.approvalKonsumer);

  const [error, setError] = React.useState("");
  const [isUploaded, setIsUploaded] = React.useState(false);

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Hanya angka
    setNoRekeningKredit(value);

    if (value.length !== 14) {
      setError("Nomor rekening harus 14 digit.");
    } else {
      setError("");
    }
  };

  React.useEffect(() => {
    if (valDetail?.stepEnam?.foto_pencairan) {
      setIsUploaded(true);
    }
  }, [valDetail?.stepEnam?.foto_pencairan]);

  React.useEffect(() => {
    let tmp = [];
    Object.entries(valDetailStepEnam).forEach(([key, value]) => {
      if (
        key != "_id" &&
        key != "id_pinjaman" &&
        key != "createdAt" &&
        key != "updatedAt"
      ) {
        tmp.push({
          key: key,
          url: value,
        });
      }
    });
    setListUrlDokumen(tmp);
  }, []);

  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  const handleCloseModalUpdatStatus = () => {
    setStatus("");
    setKeterangan("");
    setNominalPencairan("");
    setNoAkad("");
    setTanggalAkad("");
    setNoAgenda("");
    setTanggalAgenda("");
    setJenisAsuransi("");
    setBiayaAsuransi("");
    setBiayaProvisi("");
    setAnalis("");
    setBlokirAngsuran("");
  };

  const handleClick = (idPengajuanValue) => {
    setIdPengajuan(idPengajuanValue);
    dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
  };

  // const renderTimeline() {
  // if (!valDetail.history || valDetail.history.length === 0) {
  //   return <p>No history available.</p>;
  // }

  const submitFotoPencairan = () => {
    if (!kirimFotoPencairan) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "File wajib diisi!",
        showCancelButton: true,
      });
      return;
    }

    setLoadingFotoPencairan(true);
    const formData = new FormData();
    formData.append("fotoPencairan", kirimFotoPencairan);
    formData.append("idPengajuan", valDetail.id_pinjaman);

    uploadFotoPencairan(formData)
      .then((response) => {
        setLoadingFotoPencairan(false);
        if (response.status === 200) {
          setIsUploaded(true); // Nonaktifkan tombol setelah sukses
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.message,
          });
        }
      })
      .catch((error) => {
        console.error("Terjadi kesalahan saat mengirim data profil:", error);
        setLoadingFotoPencairan(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Terjadi kesalahan dalam mengirim data profil.",
        });
      });
  };

  // const submitUpdateStatus = async (e) => {
  //   e.preventDefault();

  //   // Helper validasi
  //   const isEmpty = (val) => {
  //     // null / undefined
  //     if (val === null || val === undefined) return true;

  //     // string kosong / spasi
  //     if (typeof val === "string" && val.trim() === "") return true;

  //     return false;
  //   };

  //   // 1. Validasi Status
  //   if (!status || !status.value) {
  //     return Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Status tidak boleh kosong",
  //     });
  //   }

  //   const role = auth.role;
  //   const nopeg = auth.nopeg;
  //   const isDisetujui = status.value === "Disetujui";

  //   // 2. Validasi ketika Disetujui
  //   if (isDisetujui) {
  //     const requiredFields = [
  //       {
  //         key: "Nominal Pencairan",
  //         value: nominalPencairan,
  //       },
  //       // {
  //       //   key: "Nominal Pelunasan",
  //       //   value: nominalPelunasan,
  //       // },
  //       {
  //         key: "No Akad",
  //         value: noAkad,
  //       },
  //       {
  //         key: "Tanggal Akad",
  //         value: tanggalAkad,
  //       },
  //       // {
  //       //   key: "No Agenda",
  //       //   value: noAgenda,
  //       // },
  //       // {
  //       //   key: "Tanggal Agenda",
  //       //   value: tanggalAgenda,
  //       // },
  //       // {
  //       //   key: "Jenis Asuransi",
  //       //   value: jenisAsuransi,
  //       // },
  //       {
  //         key: "Biaya Asuransi",
  //         value: biayaAsuransi,
  //       },
  //       {
  //         key: "Biaya Provisi",
  //         value: biayaProvisi,
  //       },
  //       // {
  //       //   key: "Analis",
  //       //   value: analis,
  //       // },
  //       // {
  //       //   key: "Blokir Angsuran",
  //       //   value: blokirAngsuran,
  //       // },
  //       {
  //         key: "No Rekening Kredit",
  //         value: noRekeningKredit,
  //       },
  //     ];

  //     // Cari field kosong
  //     const invalidField = requiredFields.find((field) => isEmpty(field.value));

  //     if (invalidField) {
  //       return Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: `${invalidField.key} wajib diisi`,
  //       });
  //     }

  //     // Validasi khusus periode rekon
  //     if (role === "super admin" || nopeg === "04240272") {
  //       if (isEmpty(periodeRekon)) {
  //         return Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: "Periode Rekon tidak boleh kosong",
  //         });
  //       }
  //     }
  //   } else {
  //     // Selain Disetujui
  //     if (role === "supervisor" && isEmpty(keterangan)) {
  //       return Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Keterangan tidak boleh kosong",
  //       });
  //     }
  //   }

  //   // Payload
  //   const payload = {
  //     id_pinjaman: idPengajuan,
  //     statusPengajuan: status.value,
  //     nominalPencairan,
  //     nominalPelunasan,
  //     noAkad,
  //     noAgenda,
  //     tglAkad: tanggalAkad,
  //     tglAgenda: tanggalAgenda,
  //     jenisAsuransi,
  //     biayaAsuransi,
  //     provisi: biayaProvisi,
  //     analis,
  //     blokirAngsuran,
  //     periodeRekon,
  //     noRekeningKredit,
  //     biayaAdmin: biayaAdministrasi,
  //     biayaNotaris: biayaNotaris,
  //     keterangan: role === "supervisor" && isDisetujui ? undefined : keterangan,
  //   };

  //   try {
  //     const response = await updateStatusPengajuan(payload);

  //     if (response.data.status === 200) {
  //       Swal.fire({
  //         position: "center",
  //         icon: "success",
  //         title: response.data.message,
  //         showConfirmButton: false,
  //       }).then(() => {
  //         setModalUpdateStatus(false);

  //         setStatus("");
  //         setAnalis("");
  //         setJenisAsuransi("");
  //         setBiayaAsuransi("");
  //         setBiayaProvisi("");
  //         setBlokirAngsuran("");
  //         setNoAgenda("");
  //         setNoAkad("");
  //         setNominalPencairan("");
  //         setTanggalAgenda("");
  //         setTanggalAkad("");
  //         setPeriodeRekon("");
  //         setKeterangan("");

  //         getAllPengajuan(dispatch, {
  //           status: "",
  //           tglAwal: "",
  //           tglAkhir: "",
  //           cari: "",
  //           idWilayah: "",
  //         });

  //         dispatch({
  //           type: "SET_STEP_PENGAJUAN",
  //           data: true,
  //         });
  //       });

  //       setTimeout(() => {
  //         Swal.close();
  //       }, 1000);
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: response.data.message,
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);

  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Terjadi kesalahan sistem saat memperbarui status.",
  //     });
  //   }
  // };

  const submitUpdateStatus = async (e) => {
    e.preventDefault();

    if (!status) {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status tidak boleh kosong",
      });
    }

    const isSupervisor = auth.role === "supervisor";
    const isDisetujui =
      status.value === "Disetujui" &&
      (auth.role === "supervisor" || auth.role === "super admin");

    if (isDisetujui) {
      const isInvalid =
        !nominalPencairan ||
        !noAkad ||
        !tanggalAkad ||
        !biayaAsuransi ||
        !biayaProvisi ||
        !noRekeningKredit ||
        !biayaAdministrasi ||
        !biayaNotaris;

      if (isInvalid) {
        return Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Wajib diisi semua!",
        });
      }
    } else {
      if (!keterangan && isSupervisor) {
        return Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Keterangan tidak boleh kosong",
        });
      }
    }

    const payload = isDisetujui
      ? {
          id_pinjaman: idPengajuan,
          statusPengajuan: status.value,
          nominalPencairan,
          noAkad,
          tglAkad: tanggalAkad,
          biayaAsuransi,
          provisi: biayaProvisi,
          noRekeningKredit,
          biayaAdmin: biayaAdministrasi,
          biayaNotaris,
        }
      : {
          id_pinjaman: idPengajuan,
          statusPengajuan: status.value,
          keterangan,
          nominalPencairan,
          nominalPelunasan,
          noAkad,
          noAgenda,
          tglAkad: tanggalAkad,
          tglAgenda: tanggalAgenda,
          jenisAsuransi,
          biayaAsuransi,
          provisi: biayaProvisi,
          analis,
          blokirAngsuran,
        };

    try {
      console.log(payload, "DATA UPDATE STATUS PENGAJUAN");

      const response = await updateStatusPengajuan(payload);

      if (response.data.status === 400) {
        return Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.message,
        });
      }

      Swal.fire({
        position: "center",
        icon: "success",
        title: response.data.message,
        showConfirmButton: false,
      }).then(() => {
        setModalUpdateStatus(false);

        // reset form
        setKeterangan("");
        setStatus("");
        setAnalis("");
        setJenisAsuransi("");
        setBiayaAsuransi("");
        setBiayaProvisi("");
        setBiayaAdministrasi("");
        setBiayaNotaris("");
        setBlokirAngsuran("");
        setNoAgenda("");
        setNoAkad("");
        setNominalPencairan("");
        setTanggalAgenda("");
        setTanggalAkad("");

        getAllPengajuan(dispatch, {
          status: "",
          tglAwal: "",
          tglAkhir: "",
          cari: "",
          idWilayah: "",
        });

        dispatch({
          type: "SET_STEP_PENGAJUAN",
          data: true,
        });
      });

      setTimeout(() => Swal.close(), 1000);
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Terjadi kesalahan pada sistem",
      });
    }
  };

  const statusStyle = (status) => {
    switch (status) {
      case "Menunggu Konfirmasi":
        return { backgroundColor: "#FFF5CD", textColor: "#FFAF05" };
      // case "Diajukan":
      //   return { backgroundColor: "#BAD9FD", textColor: "#1776F1" };
      case "Diproses":
        return { backgroundColor: "#fcceb3", textColor: "#fa5d02" };
      case "Disetujui":
        return { backgroundColor: "#E3FCDB", textColor: "#5AC967" };
      case "Revisi":
        return { backgroundColor: "#FFE2E6", textColor: "#FF2B4B" };
      case "Ditolak":
        return { backgroundColor: "#E10F00", textColor: "#FFFFFF" };
      default:
        return {};
    }
  };

  const options = [
    {
      value: "",
      label: "Pilih Status",
      isDisabled: true,
    },
    {
      value: "Diproses",
      label: "Diproses",
    },
    {
      value: "Disetujui",
      label: "Disetujui",
    },
    {
      value: "Revisi",
      label: "Revisi",
    },
    {
      value: "Ditolak",
      label: "Ditolak",
    },
  ];

  if (
    userRole === "super admin" ||
    userRole === "admin" ||
    userRole === "koordinator wilayah"
  ) {
    // Tambahkan opsi "Menunggu Konfirmasi" jika pengguna adalah super admin
    options.splice(1, 0, {
      value: "Menunggu Konfirmasi",
      label: "Menunggu Konfirmasi",
    });
  }

  // const submitRevisi = () => {
  //   if (keterangan === "") {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Keterangan tidak boleh kosong",
  //     });
  //   } else {
  //     revisiPengajuan({
  //       idPengajuan: idPengajuan,
  //       keterangan: keterangan,
  //     }).then((response) => {
  //       if (response.data.status === 200) {
  //         Swal.fire({
  //           position: "center",
  //           icon: "success",
  //           title: response.data.message,
  //         });
  //         setTimeout(() => {
  //           Swal.close();
  //         }, 5000);
  //         setModalRevisi(false);
  //       } else if (response.data.status === 400) {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: response.data.message,
  //         });
  //       }
  //     });
  //   }
  // };

  return (
    <>
      <Modal
        size="lg"
        show={modalUpdateStatus}
        onHide={() => {
          setModalUpdateStatus(false);
          handleCloseModalUpdatStatus();
        }}
        centered
        style={{ backdropFilter: "blur(8px)" }} // Efek blur premium
        contentClassName="border-0 shadow-2xl"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-4 pb-5">
          {/* HEADER VISUAL */}
          <div className="text-center mb-4">
            <div
              className="p-3 d-inline-block mb-3 shadow-sm"
              style={{
                background: "linear-gradient(135deg, #2e3192 0%, #f90203 100%)",
                borderRadius: "15px",
                color: "white",
              }}
            >
              <i
                className="fas fa-edit fa-2x"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3
              className="font-weight-black text-dark m-0"
              style={{ letterSpacing: "-0.5px" }}
            >
              UPDATE STATUS PENGAJUAN
            </h3>
            <p className="text-muted small">
              Kelola data persetujuan dan rincian administratif nasabah
            </p>
          </div>

          <Form className="px-md-3">
            <div className="bg-white p-4 rounded-xl shadow-sm border">
              <Row>
                {/* SELEKSI STATUS UTAMA */}
                <Col md="12" className="mb-4">
                  <Form.Group>
                    <label className="small fw-800 text-muted text-uppercase mb-2 d-block">
                      Status Baru
                    </label>
                    <Select
                      classNamePrefix="react-select"
                      onChange={(value) => setStatus(value)}
                      options={options}
                      placeholder="Pilih Status..."
                      styles={{
                        control: (b) => ({
                          ...b,
                          borderRadius: "12px",
                          height: "50px",
                          border: "1px solid #e2e8f0",
                          backgroundColor: "#f8fafc",
                        }),
                      }}
                    />
                  </Form.Group>
                </Col>

                {/* INPUT KETERANGAN (Jika Status Memerlukan Alasan) */}
                {[
                  "Menunggu Konfirmasi",
                  "Diproses",
                  "Revisi",
                  "Ditolak",
                ].includes(status.value) && (
                  <Col
                    md="12"
                    className="mb-3 animate__animated animate__fadeIn"
                  >
                    <Form.Group>
                      <label className="small fw-800 text-muted text-uppercase mb-2 d-block">
                        Keterangan / Alasan
                      </label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        onChange={(e) => setKeterangan(e.target.value)}
                        className="border-0 bg-light p-3 fw-600"
                        style={{ borderRadius: "12px", fontSize: "14px" }}
                        placeholder="Tuliskan keterangan di sini..."
                      />
                    </Form.Group>
                  </Col>
                )}

                {/* AREA KHUSUS DISETUJUI (ADMIN/SUPER ADMIN) */}
                {status.value === "Disetujui" &&
                  ["admin", "super admin"].includes(auth.role) && (
                    <Col
                      md="12"
                      className="mb-4 animate__animated animate__fadeIn"
                    >
                      <div
                        className="p-3 mb-3 bg-light rounded-lg border-left border-primary"
                        style={{ borderLeftWidth: "5px" }}
                      >
                        <label className="small fw-800 text-primary mb-1 d-block">
                          PERIODE REKON SAAT INI
                        </label>
                        <span className="h6 font-weight-bold">
                          {valDetail.periodeRekon === ""
                            ? "-"
                            : moment(valDetail.periodeRekon).format(
                                "DD MMMM YYYY",
                              )}
                        </span>
                      </div>
                      <Form.Group>
                        <label className="small fw-800 text-muted text-uppercase mb-2 d-block">
                          Pilih Periode Rekon Baru
                        </label>
                        <Form.Control
                          type="date"
                          onChange={(e) => setPeriodeRekon(e.target.value)}
                          className="border-0 bg-light p-3 fw-700"
                          style={{ borderRadius: "12px", height: "50px" }}
                        />
                      </Form.Group>
                    </Col>
                  )}

                {/* FORM ADMINISTRATIF DETAIL (DISETUJUI) */}
                {status.value === "Disetujui" &&
                  ["supervisor", "super admin", "admin"].includes(
                    auth.role,
                  ) && (
                    <>
                      <Col md="6" className="mb-3">
                        <label className="small fw-800 text-muted text-uppercase mb-1">
                          Nominal Pencairan
                        </label>
                        <CurrencyInput
                          className="form-control border-0 bg-light fw-700"
                          style={{
                            height: "50px",
                            borderRadius: "12px",
                            fontSize: "15px",
                          }}
                          placeholder="Rp 0"
                          prefix="Rp "
                          groupSeparator="."
                          decimalSeparator=","
                          onValueChange={(v) => setNominalPencairan(v)}
                        />
                      </Col>
                      <Col md="6" className="mb-3">
                        <label className="small fw-800 text-muted text-uppercase mb-1">
                          No. Rekening Kredit
                        </label>
                        <Form.Control
                          type="text"
                          value={noRekeningKredit}
                          onChange={handleChange}
                          maxLength={14}
                          className="border-0 bg-light fw-700 h-50-custom"
                          style={{ height: "50px", borderRadius: "12px" }}
                          placeholder="Max 14 Digit"
                        />
                      </Col>
                      <Col md="6" className="mb-3">
                        <label className="small fw-800 text-muted text-uppercase mb-1">
                          No. Akad
                        </label>
                        <Form.Control
                          onChange={(e) => setNoAkad(e.target.value)}
                          className="border-0 bg-light fw-700"
                          style={{ height: "50px", borderRadius: "12px" }}
                        />
                      </Col>
                      <Col md="6" className="mb-3">
                        <label className="small fw-800 text-muted text-uppercase mb-1">
                          Tanggal Akad
                        </label>
                        <Form.Control
                          type="date"
                          onChange={(e) => setTanggalAkad(e.target.value)}
                          className="border-0 bg-light fw-700"
                          style={{ height: "50px", borderRadius: "12px" }}
                        />
                      </Col>
                      <Col md="6" className="mb-3">
                        <label className="small fw-800 text-muted text-uppercase mb-1">
                          Biaya Asuransi
                        </label>
                        <CurrencyInput
                          className="form-control border-0 bg-light fw-700"
                          style={{ height: "50px", borderRadius: "12px" }}
                          prefix="Rp "
                          onValueChange={(v) => setBiayaAsuransi(v)}
                        />
                      </Col>
                      <Col md="6" className="mb-3">
                        <label className="small fw-800 text-muted text-uppercase mb-1">
                          Biaya Provisi
                        </label>
                        <CurrencyInput
                          className="form-control border-0 bg-light fw-700"
                          style={{ height: "50px", borderRadius: "12px" }}
                          prefix="Rp "
                          onValueChange={(v) => setBiayaProvisi(v)}
                        />
                      </Col>
                      <Col md="6" className="mb-3">
                        <label className="small fw-800 text-muted text-uppercase mb-1">
                          Biaya Administrasi
                        </label>
                        <CurrencyInput
                          className="form-control border-0 bg-light fw-700"
                          style={{ height: "50px", borderRadius: "12px" }}
                          prefix="Rp "
                          onValueChange={(v) => setBiayaAdministrasi(v)}
                        />
                      </Col>
                      <Col md="6" className="mb-3">
                        <label className="small fw-800 text-muted text-uppercase mb-1">
                          Biaya Notaris
                        </label>
                        <CurrencyInput
                          className="form-control border-0 bg-light fw-700"
                          style={{ height: "50px", borderRadius: "12px" }}
                          prefix="Rp "
                          onValueChange={(v) => setBiayaNotaris(v)}
                        />
                      </Col>

                      {/* FOTO PENCAIRAN SECTION */}
                      <Col md="12" className="mt-3">
                        <div className="p-4 border-dashed rounded-xl bg-light text-center">
                          <label className="fw-900 text-dark d-block mb-3">
                            DOKUMENTASI FOTO PENCAIRAN
                          </label>
                          {isUploaded ? (
                            <div className="text-success fw-800 mb-2">
                              <i className="fas fa-check-circle mr-2"></i> File
                              Berhasil Diunggah
                            </div>
                          ) : (
                            <div className="custom-file-upload">
                              <input
                                type="file"
                                accept=".png, .jpg, .jpeg"
                                onChange={(e) =>
                                  setKirimFotoPencairan(e.target.files[0])
                                }
                                className="mb-3 d-block mx-auto"
                              />
                              <Button
                                className="px-4 border-0 shadow-sm fw-800"
                                style={{
                                  backgroundColor: "#2e3192",
                                  borderRadius: "10px",
                                }}
                                onClick={submitFotoPencairan}
                                disabled={loadingFotoPencairan}
                              >
                                {loadingFotoPencairan ? (
                                  <Spinner animation="border" size="sm" />
                                ) : (
                                  "UNGGAH FOTO SEKARANG"
                                )}
                              </Button>
                            </div>
                          )}
                        </div>
                      </Col>
                    </>
                  )}
              </Row>
            </div>

            {/* SUBMIT ACTION */}
            <div className="mt-4">
              <Button
                className="btn-block py-3 border-0 fw-900 shadow-lg"
                style={{
                  background:
                    "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                  borderRadius: "15px",
                  color: "white",
                  fontSize: "16px",
                }}
                onClick={submitUpdateStatus}
              >
                SIMPAN PERUBAHAN STATUS
              </Button>
              {/* <Button
                variant="link"
                className="btn-block mt-2 text-muted fw-700 text-decoration-none"
                onClick={() => setModalUpdateStatus(false)}
              >
                Batal & Tutup
              </Button> */}
            </div>
          </Form>
        </Modal.Body>

        <style>{`
    .fw-800 { font-weight: 800; }
    .fw-900 { font-weight: 900; }
    .fw-700 { font-weight: 700; }
    .rounded-xl { border-radius: 15px !important; }
    .border-dashed { border: 2px dashed #cbd5e1; }
    .animate__animated { animation-duration: 0.5s; }
  `}</style>
      </Modal>
      <Container fluid className="pt-3">
        <Row>
          {/* BAGIAN UTAMA DETAIL */}
          <Col lg={pengajuan.valueCol} md="12">
            <Card
              className="border-0 shadow-sm"
              style={{ borderRadius: "20px" }}
            >
              {/* HEADER: Navigasi & Judul */}
              <Card.Header className="bg-white border-0 pt-4 px-4 d-flex flex-column flex-md-row align-items-center justify-content-between">
                <div className="d-flex align-items-center mb-3 mb-md-0">
                  <Button
                    className="btn-icon shadow-sm mr-3 d-flex align-items-center justify-content-center"
                    type="button"
                    variant="white"
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "12px",
                      border: "none",
                      backgroundColor: "#F1F5F9",
                      color: "#1D3557",
                      flexShrink: 0, // Mencegah tombol gepeng saat layar kecil
                    }}
                    onClick={handleClick}
                  >
                    <i
                      className="fas fa-arrow-left"
                      style={{ fontSize: "18px" }}
                    ></i>
                  </Button>

                  {/* TEXT CONTAINER - Menggunakan flex-column agar Judul & ID rapi ke bawah */}
                  <div className="d-flex flex-column justify-content-center">
                    <h3
                      style={{
                        fontSize: "22px",
                        fontWeight: "800",
                        textTransform: "uppercase",
                        color: "#1D3557",
                        margin: 0, // Hapus margin bawaan h3 agar tidak merusak alignment
                        lineHeight: "1.2",
                      }}
                    >
                      Detail Pengajuan
                    </h3>
                    <div className="d-flex align-items-center mt-1">
                      <span className="text-muted small fw-bold mr-1">ID:</span>
                      <span
                        className="text-primary fw-800"
                        style={{ fontSize: "14px", letterSpacing: "0.5px" }}
                      >
                        {valDetail.id_pinjaman}
                      </span>

                      {/* IKON SALIN DENGAN NOTIFIKASI SWAL */}
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Salin ID</Tooltip>}
                      >
                        <i
                          className="far fa-copy ml-2 text-muted"
                          style={{
                            cursor: "pointer",
                            fontSize: "14px",
                            transition: "all 0.2s",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.color = "#007bff")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.color = "#6c757d")
                          }
                          onClick={() => {
                            // 1. Fungsi Salin
                            navigator.clipboard.writeText(
                              valDetail.id_pinjaman,
                            );

                            // 2. Munculkan Notifikasi
                            Swal.fire({
                              icon: "success",
                              title: "ID Tersalin!",
                              text: valDetail.id_pinjaman,
                              showConfirmButton: false,
                              timer: 1000, // Hilang otomatis dalam 1.2 detik
                              width: "500px",
                              customClass: {
                                title: "fs-5", // Ukuran font judul lebih kecil agar proporsional
                              },
                            });
                          }}
                        ></i>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>

                {/* ACTION BUTTONS: Grouping */}
                <div className="d-flex flex-wrap justify-content-center gap-2">
                  <Button
                    disabled={valDetail.statusPengajuan === "Disetujui"}
                    className="btn-fill border-0 shadow-sm mx-1"
                    style={{
                      backgroundColor: "#116D6E",
                      borderRadius: "10px",
                      fontWeight: "700",
                      fontSize: "12px",
                      padding: "10px 15px",
                      cursor:
                        valDetail.statusPengajuan === "Disetujui"
                          ? "not-allowed"
                          : "pointer",
                    }}
                    onClick={() => {
                      setIdPengajuan(valDetail.id_pinjaman);
                      setModalUpdateStatus(true);
                    }}
                  >
                    <i className="fas fa-edit mr-2"></i> UPDATE MANUAL
                  </Button>

                  {/* {[
                    "super admin",
                    "admin",
                    "koordinator wilayah",
                    "area manager",
                    "supervisor",
                  ].includes(auth.role) && (
                    <>
                      <Button
                        disabled={
                          valDetail.statusPengajuan !== "Menunggu Konfirmasi"
                        }
                        className="btn-fill border-0 shadow-sm mx-1"
                        style={{
                          backgroundColor: "#F63F4B",
                          borderRadius: "10px",
                          fontWeight: "700",
                          fontSize: "12px",
                          padding: "10px 15px",
                        }}
                        onClick={() => {
                          setIdPengajuan(valDetail.id_pinjaman);
                          setModalRevisi(true);
                        }}
                      >
                        <i className="fas fa-undo mr-2"></i> REVISI
                      </Button>
                      <Button
                        disabled={
                          valDetail.statusPengajuan !== "Menunggu Konfirmasi"
                        }
                        className="btn-fill border-0 shadow-sm mx-1"
                        style={{
                          backgroundColor: "#1D3557",
                          borderRadius: "10px",
                          fontWeight: "700",
                          fontSize: "12px",
                          padding: "10px 15px",
                        }}
                        onClick={ajukanPengajuan}
                      >
                        <i className="fas fa-paper-plane mr-2"></i> AJUKAN
                      </Button>
                    </>
                  )} */}
                </div>
              </Card.Header>

              <hr className="mx-4 my-2 opacity-50" />

              <Card.Body className="px-4 pb-4">
                {/* BANNER STATUS: Elegant Alert Style */}
                <div
                  className="d-flex align-items-center p-3 mb-4 shadow-sm"
                  style={{
                    backgroundColor: statusStyle(valDetail.statusPengajuan)
                      .backgroundColor,
                    borderRadius: "15px",
                    borderLeft: `6px solid ${statusStyle(valDetail.statusPengajuan).textColor}`,
                  }}
                >
                  <div className="mr-3 ml-2">
                    <i
                      className="fas fa-info-circle fa-2x"
                      style={{
                        color: statusStyle(valDetail.statusPengajuan).textColor,
                      }}
                    ></i>
                  </div>
                  <div>
                    <h6
                      className="fw-800 mb-1"
                      style={{
                        color: statusStyle(valDetail.statusPengajuan).textColor,
                      }}
                    >
                      STATUS: {valDetail.statusPengajuan.toUpperCase()}
                    </h6>
                    <p className="mb-0 small text-dark opacity-75">
                      {valDetail.statusPengajuan === "Menunggu Konfirmasi" &&
                        "Pengajuan Anda sedang menunggu tahap pengecekan."}
                      {valDetail.statusPengajuan === "Diproses" &&
                        "Pengajuan sedang dalam proses oleh pihak Bank KALTIMTARA."}
                      {valDetail.statusPengajuan === "Revisi" &&
                        (valDetail.history[0]?.keterangan ||
                          "Harap perbaiki data sesuai instruksi.")}
                      {valDetail.statusPengajuan === "Disetujui" &&
                        "Pengajuan pinjaman telah disetujui oleh pihak Bank KALTIMTARA."}
                      {valDetail.statusPengajuan === "Ditolak" &&
                        "Pengajuan pinjaman telah ditolak oleh pihak Bank KALTIMTARA."}
                      {valDetail.statusPengajuan === "Diajukan" &&
                        "Pengajuan telah diajukan ke pihak Bank KALTIMTARA."}
                    </p>
                  </div>
                </div>

                <Tab.Container id="detail-tabs" defaultActiveKey="step1">
                  <div className="d-flex justify-content-center mb-4">
                    <Nav
                      variant="pills"
                      className="bg-light p-1 shadow-inner"
                      style={{
                        borderRadius: "12px",
                        border: "1px solid #e2e8f0",
                        display: "inline-flex", // Membuat lebar mengikuti jumlah tab
                        flexWrap: "nowrap",
                        width: "auto", // Mencegah width 100%
                      }}
                    >
                      <Nav.Item>
                        <Nav.Link
                          eventKey="step1"
                          className="custom-step-pill px-4"
                        >
                          Nasabah
                        </Nav.Link>
                      </Nav.Item>
                      {valDetail.statusMenikah === "Kawin" && (
                        <Nav.Item>
                          <Nav.Link
                            eventKey="step2"
                            className="custom-step-pill px-4"
                          >
                            Pasangan
                          </Nav.Link>
                        </Nav.Item>
                      )}
                      <Nav.Item>
                        <Nav.Link
                          eventKey="step3"
                          className="custom-step-pill px-4"
                        >
                          Pekerjaan
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="step4"
                          className="custom-step-pill px-4"
                        >
                          Pinjaman
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="step5"
                          className="custom-step-pill px-4"
                        >
                          Jaminan
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="step6"
                          className="custom-step-pill px-4"
                        >
                          Dokumen
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="fotoKunjungan"
                          className="custom-step-pill px-4"
                        >
                          Foto Kunjungan
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </div>

                  <Tab.Content className="mt-3 animation-fade">
                    <Tab.Pane eventKey="step1">
                      <Step1 />
                    </Tab.Pane>

                    <Tab.Pane eventKey="step2">
                      <Step2 />
                    </Tab.Pane>

                    <Tab.Pane eventKey="step3">
                      <Step3 />
                    </Tab.Pane>

                    <Tab.Pane eventKey="step4">
                      <Step4 />
                    </Tab.Pane>

                    <Tab.Pane eventKey="step5">
                      <Step5 />
                    </Tab.Pane>

                    <Tab.Pane eventKey="step6">
                      <Step6 />
                    </Tab.Pane>
                    <Tab.Pane eventKey="fotoKunjungan">
                      <FotoKunjungan />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
                <style>{`
  .custom-step-pill {
    color: #64748b !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    border-radius: 10px !important;
    padding: 8px 20px !important;
    transition: all 0.3s ease;
  }
  .custom-step-pill.active {
    background-color: #3b82f6 !important; /* Biru seperti di gambar */
    color: white !important;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
  }
  .shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06) !important;
  }
`}</style>
              </Card.Body>
            </Card>
          </Col>

          {/* PREVIEW DOKUMEN (SIDEBAR) */}
          {pengajuan.valueCol !== "12" && (
            <Col lg={pengajuan.valueColPrev} md="12" className="mt-4 mt-lg-0">
              <Card
                className="border-0 shadow-sm sticky-top"
                style={{ borderRadius: "20px", top: "20px" }}
              >
                <Card.Header className="bg-white border-0 pt-4 px-4 d-flex align-items-center justify-content-between">
                  <h5 className="fw-800 text-dark mb-0">PREVIEW DOKUMEN</h5>
                  <Button
                    variant="link"
                    className="text-danger p-0 shadow-none"
                    onClick={() => dispatch({ type: "HIDE_DOKUMEN" })}
                  >
                    <i className="fas fa-times-circle fa-lg"></i>
                  </Button>
                </Card.Header>
                <Card.Body className="p-3">
                  <div
                    className="rounded-lg overflow-hidden border shadow-inner"
                    style={{ borderRadius: "15px", height: "700px" }}
                  >
                    <iframe
                      src={urlPreview}
                      width="100%"
                      height="100%"
                      frameBorder="0"
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>

        <style>{`
    .custom-step-pill {
      color: #64748b !important;
      font-weight: 700 !important;
      font-size: 12px !important;
      border-radius: 10px !important;
      padding: 10px 20px !important;
      white-space: nowrap;
    }
    .custom-step-pill.active {
      background-color: #3090C7 !important;
      color: white !important;
      box-shadow: 0 4px 10px rgba(48, 144, 199, 0.3) !important;
    }
    .animation-fade { animation: fadeIn 0.3s ease-in-out; }
    @keyframes fadeIn { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: translateY(0); } }
    .shadow-inner { box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.05); }
    .gap-2 { gap: 0.5rem; }
  `}</style>
      </Container>

      <Card
        className="mt-5 border-0 shadow-lg"
        style={{ borderRadius: "25px" }}
      >
        <Card.Header className="bg-white border-0 pt-5 px-4 text-center">
          <div
            className="d-inline-block p-3 mb-3"
            style={{ backgroundColor: "#f8fafc", borderRadius: "20px" }}
          >
            <i
              className="fas fa-history fa-2x text-primary"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                margin: 0,
                padding: 0,
                lineHeight: 1,
                textAlign: "center",
              }}
            ></i>
          </div>
          <h3
            className="font-weight-black text-dark m-0"
            style={{ letterSpacing: "1px", textTransform: "uppercase" }}
          >
            Riwayat Pengajuan
          </h3>
          <hr
            className="mx-auto mt-3 w-25"
            style={{
              height: "4px",
              backgroundColor: "#f90203",
              borderRadius: "10px",
              border: "none",
            }}
          />
        </Card.Header>

        <Card.Body className="px-4 pb-5">
          <div
            style={{
              maxHeight: "600px",
              overflowY: "auto",
              paddingRight: "10px",
            }}
            className="custom-scrollbar"
          >
            <VerticalTimeline lineColor="#e2e8f0" layout="1-column-left">
              {valDetail.history.map((item, index) => {
                const isDisetujui = item.status === "Disetujui";
                const isRevisi = item.status === "Revisi";
                const getApprover = (code) =>
                  code === "0"
                    ? "Supervisor"
                    : code === "1"
                      ? "Korcab"
                      : "Konsumer";

                return (
                  <VerticalTimelineElement
                    key={index}
                    className="vertical-timeline-element--education"
                    dateClassName="fw-900 text-muted"
                    date={moment(item.date).format("DD MMMM YYYY | HH:mm")}
                    contentStyle={{
                      background: "#ffffff",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
                      borderRadius: "15px",
                      borderLeft:
                        "8px solid " +
                        (item.status === "Menunggu Konfirmasi"
                          ? "#FFAF05"
                          : item.status === "Diproses"
                            ? "#fa5d02"
                            : item.status === "Disetujui"
                              ? item.statusCode === "1"
                                ? "#00BFFF"
                                : item.statusCode === "2"
                                  ? "#0000FF"
                                  : "#5AC967"
                              : item.status === "Revisi"
                                ? "#FF2B4B"
                                : "#E10F00"),
                    }}
                    iconStyle={{
                      background:
                        item.status === "Menunggu Konfirmasi"
                          ? "#FFAF05"
                          : item.status === "Diproses"
                            ? "#fa5d02"
                            : item.status === "Disetujui"
                              ? item.statusCode === "1"
                                ? "#00BFFF"
                                : item.statusCode === "2"
                                  ? "#0000FF"
                                  : "#5AC967"
                              : item.status === "Revisi"
                                ? "#FF2B4B"
                                : "#E10F00",
                      color: "#fff",
                      boxShadow:
                        "0 0 0 4px #fff, inset 0 2px 0 rgba(0,0,0,0.08), 0 3px 0 4px rgba(0,0,0,0.05)",
                    }}
                    icon={
                      <i
                        className={`fas fa-${
                          item.status === "Disetujui"
                            ? "check"
                            : item.status === "Revisi"
                              ? "exclamation"
                              : "info"
                        }`}
                        style={{
                          fontSize: "20px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%", // Mengambil tinggi penuh kontainer ikon
                          width: "100%", // Mengambil lebar penuh kontainer ikon
                        }}
                      ></i>
                    }
                  >
                    <h5 className="font-weight-black text-dark mb-3">
                      {isDisetujui
                        ? `DISETUJUI ${getApprover(item.statusCode)}`
                        : isRevisi
                          ? `REVISI ${getApprover(item.statusCode)}`
                          : item.status.toUpperCase()}
                    </h5>
                    <div className="p-3 bg-light rounded-lg">
                      <Row className="align-items-center">
                        <Col sm="3" className="fw-800 text-muted small">
                          KETERANGAN
                        </Col>
                        <Col
                          sm="1"
                          className="d-none d-sm-block text-center text-muted"
                        >
                          :
                        </Col>
                        <Col sm="8" className="fw-700 text-dark small">
                          {!item.keterangan || item.keterangan === ""
                            ? "Tidak ada keterangan tambahan"
                            : item.keterangan}
                        </Col>
                      </Row>
                    </div>
                  </VerticalTimelineElement>
                );
              })}
            </VerticalTimeline>
          </div>
        </Card.Body>
      </Card>
    </>
  );
}

export default indexSteps;
